export const exceptGameType = (gameType) => {
  const except = ["LOBBY"];

  return except.includes(gameType);
};
